module.exports = __webpack_public_path__ + "static/media/call-icon.720f7046.svg";